/* eslint-disable */
require('./capital_lvl')
require('./corvette_lvl')
require('./counter_intelligence')
require('./credit')
require('./defense')
require('./fighter_lvl')
require('./frigate_lvl')
require('./habitation')
require('./happiness')
require('./ideology')
require('./mobility')
require('./population')
require('./production')
require('./radar')
require('./reallocation_time')
require('./remove_contact')
require('./resource')
require('./technology')
require('./training_cost')
require('./training_xp')
require('./workforce')
